import type { AxiosInstance } from 'axios'
import { castWaterConsumption } from 'src/types/water'
import type { WaterBody, WaterConsumptionType } from 'src/types/water'
import { format } from 'date-fns'

export class WaterConsumptionApi {
  api: AxiosInstance

  urls = {
    waterConsumption: () => 'water-consumption/' as const,
    waterConsumptionCard: (id: WaterConsumptionType['id']) => `water-consumption/${id}/`,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  deleteWaterConsumption = async (id: WaterConsumptionType['id']) => {
    return await this.api.delete(this.urls.waterConsumptionCard(id))
  }

  getWaterConsumption = async (date: Date): Promise<WaterConsumptionType[]> => {
    const params = { date: format(date, 'dd-MM-yyyy') }
    const response = await this.api.get<WaterConsumptionType[]>(
      this.urls.waterConsumption(),
      { params }
    )
    return response.data.map(row => castWaterConsumption(row))
  }

  postWaterConsumption = async (body: WaterBody): Promise<WaterConsumptionType> => {
    const response = await this.api.post<WaterConsumptionType>(
      this.urls.waterConsumption(), body
    )
    return response.data
  }
}
